import { Renewal } from "pmt-types/src/models/Renewal.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationAddRenewal = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (renewal: Renewal) => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_HOST}/renewals`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: accessToken ?? "",
            },
            body: JSON.stringify(renewal),
          },
        );

        if (!response.ok) {
          throw new Error("Failed to upsert renewal");
        }

        return (await response.json()) as Renewal;
      } catch (error) {
        // Renewal generation can take > than the API gateway timeout, polling as a fallback
        let isWaitingForRenewal = true; // response.status === 504;
        do {
          // Poll in 10 second intervals
          await new Promise((resolve) => setTimeout(resolve, 10000));

          const response = await fetch(
            `${import.meta.env.VITE_API_HOST}/sources/${
              renewal.source.id
            }/projects/${renewal.project.id}/renewals/${renewal.id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                authorization: accessToken ?? "",
              },
            },
          );

          isWaitingForRenewal = response.status === 404;

          if (response.ok) {
            return (await response.json()) as Renewal;
          }
        } while (isWaitingForRenewal);

        throw new Error("Failed to upsert renewal after retries");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert renewal", error, data);
      },
    },
  );
};
